import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const EditClient = ({ editObj }) => {
  const [editObjData, setEditObjData] = useState([]);

  useEffect(() => {
    if (editObj) {
      setEditObjData(editObj);
    }
  }, [editObj]);

  return (
    <div>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightEditReg"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "50%", maxWidth: "50%" }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Edit Client</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body">
          <form>
            <div className="content">
              <div className="row">
                <div className="col-6 mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editObjData?.Name}
                    onChange={(e) =>
                      setEditObjData({ ...editObjData, Name: e.target.value })
                    }
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Company</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editObjData?.Company}
                    onChange={(e) =>
                      setEditObjData({
                        ...editObjData,
                        Company: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editObjData?.Email}
                    onChange={(e) =>
                      setEditObjData({ ...editObjData, Email: e.target.value })
                    }
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Contact No</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editObjData?.Phone}
                    onChange={(e) =>
                      setEditObjData({ ...editObjData, Phone: e.target.value })
                    }
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Location</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editObjData?.Location}
                    onChange={(e) =>
                      setEditObjData({
                        ...editObjData,
                        Location: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Website</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editObjData?.Website}
                    onChange={(e) =>
                      setEditObjData({
                        ...editObjData,
                        Website: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-secondary d-flex mt-3 me-2"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary d-flex mt-3"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

EditClient.propTypes = {
  editObj: PropTypes.object.isRequired,
};

export default EditClient;
